import { type POPDFCustomFieldDisplayRow } from '@webapp/modules/purchasing/business-logic/use-cases/getPOPDFCustomFieldDisplay'
import { useQueryPOPDFCustomFieldDisplay } from '@webapp/modules/purchasing/features/list-po-pdf-custom-field-display/models'

type UsePOPDFCustomFieldDisplayPresenterReturn = {
  data: {
    poRows: POPDFCustomFieldDisplayRow[]
    orderItemRows: POPDFCustomFieldDisplayRow[]
  }
  states: {
    isLoading: boolean
  }
}

export const usePOPDFCustomFieldDisplayPresenter =
  (): UsePOPDFCustomFieldDisplayPresenterReturn => {
    const { poFields, orderItemFields, isLoading } =
      useQueryPOPDFCustomFieldDisplay()

    return {
      data: {
        poRows: poFields,
        orderItemRows: orderItemFields,
      },
      states: {
        isLoading,
      },
    }
  }
